import * as mutations from "../../mutation-types"

export const processCompany = (store, item) => {
    if (item.projects) {
        _.each(item.projects, item => store.dispatch('processProject', item))
        delete item.projects
    }

    if (item.proposals) {
        _.each(item.proposals, item => store.dispatch('processProposal', item))
        delete item.proposals
    }

    store.commit(mutations.ADD_OR_UPDATE_COMPANY, item)
}

export const fetchCompanies = (store, params) => {
    return axios.get(`/api/companies`, { params })
        .then(res => {
            _.each(res.data.data, item => processCompany(store, item))
            return res
        })
}

export const createCompany = (store, company) => {
    return axios.post(`/api/companies`, company)
        .then(res => {
            processCompany(store, res.data.data)
            return res
        })
}

export const fetchDuplicatedCompanies = (store, params) => {
    return axios.get(`/api/companies/get-duplicated`, { params })
}

export const fetchSimilarDuplicatedCompanies = (store, params) => {
    return axios.get(`/api/companies/get-similar-duplicated`, { params })
}

export const mergeDuplicatedCompanies = (store, items) => {
    return axios.post(`/api/companies/merge-duplicated`, { items })
}

export const mergeSimilarDuplicatedCompanies = (store, items) => {
    return axios.post(`/api/companies/merge-similar-duplicated`, { items })
}

export const updateCompany = (store, item) => {
    return axios.patch(`/api/companies/${item.id}`, item)
        .then(res => {
            processCompany(store, res.data.data)
            return res
        })
}

export const createOrUpdateCompany = (store, item) => {
    return item.id ?
        updateCompany(store, item) :
        createCompany(store, item)
}

export const fetchCompanyById = (store, id) => {
    return axios.get(`/api/companies/${id}`).then(response => {
        processCompany(store, response.data.data)
        console.log(response)
        return response
    })
};

export const fetchTaskBasedCompanies = (store) => {
    return fetchCompanies(store, { task_based: 1 })
};

export const removeCompany = (store, item) => {
    return axios.delete(`/api/companies/${item.id}`)
        .then(res => {
            store.commit(mutations.REMOVE_COMPANY, item)
            return res
        })
}
